import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InnerBlocks,
    } = window.wp.editor;

    registerBlockType('custom-gutenberg/seahorse', {
        // built-in attributes
        title: 'Seahorse background image',
        description: 'Seahorse background image',
        icon: '',
        category: 'custom-containers',
        example: {},

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                classes
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            return (
                <div class={ classes }>
                    <InnerBlocks />
                </div>
            );
        },

        save({ attributes }) {

            const {
                classes
            } = attributes;

            return (
                <div className={ "seahorse-background-image " + (classes ? classes : '') }>
                    <InnerBlocks.Content />
                </div>
            );
        },
    });
}